// FILE: src/app/(portal)/_wiki_components/wiki-nav.ts
// VERSION: 1.0.0
// START_MODULE_CONTRACT:
// PURPOSE: Единый источник навигации оболочки базы знаний OXPA.PRO — разделы Вики, охранные услуги, инструменты. Используется сайдбаром, мобильной панелью и хлебными крошками.
// SCOPE: [wiki, uslugi, fz-427, tools, навигация базы знаний]
// INPUT: Нет (статические данные)
// OUTPUT: WIKI_CATEGORIES, WIKI_BREADCRUMB_CATEGORIES, KB_SERVICE_LINKS, KB_TOOL_LINKS, типы WikiNavCategory и WikiNavLink
// KEYWORDS: [DOMAIN(knowledge-base): навигация; TECH(nextjs): shared-data; CONCEPT(seo): перелинковка]
// LINKS: [src/app/(portal)/_wiki_components/wiki-shell.tsx, src/app/(portal)/wiki/layout.tsx]
// LINKS_TO_SPECIFICATION: [Задача B — унификация оболочки базы знаний]
// END_MODULE_CONTRACT
//
// START_CHANGE_SUMMARY:
// LAST_CHANGE: 1.0.0 — Навигация вынесена из wiki/layout.tsx, добавлены /fz-427, /uslugi/montazh-oborudovaniya и инструменты /tools/*.
// END_CHANGE_SUMMARY

import {
  BookOpen,
  Briefcase,
  Building2,
  ClipboardCheck,
  GraduationCap,
  Handshake,
  Lock,
  type LucideIcon,
  Search,
  Shield,
  ShieldCheck,
  Star,
  Users,
} from "lucide-react";

export interface WikiNavCategory {
  icon: LucideIcon;
  title: string;
  slug: string;
}

export interface WikiNavLink {
  href: string;
  label: string;
  icon: LucideIcon;
}

/** Категории Вики — те же 8 разделов, что и в /wiki (wiki/page.tsx) */
export const WIKI_CATEGORIES: WikiNavCategory[] = [
  { icon: Shield, title: "Как стать охранником", slug: "kak-stat-ohrannikom" },
  { icon: ClipboardCheck, title: "Удостоверение охранника", slug: "udostoverenie" },
  { icon: Users, title: "Медицинские документы", slug: "medicinskiye-dokumenty" },
  { icon: Building2, title: "Лицензирование ЧОП", slug: "licenzirovanie-chop" },
  { icon: Lock, title: "Специальные лицензии", slug: "specialnye-licenzii" },
  { icon: BookOpen, title: "Законодательство", slug: "zakonodatelstvo" },
  { icon: Briefcase, title: "Работа на объекте", slug: "rabota-na-objekte" },
  { icon: Star, title: "Карьера и развитие", slug: "kariera" },
];

/** Плоский список для WikiBreadcrumbs (ему нужны только title + slug) */
export const WIKI_BREADCRUMB_CATEGORIES = WIKI_CATEGORIES.map(({ title, slug }) => ({
  title,
  slug,
}));

/**
 * Короткий список охранных услуг для сайдбара.
 * <MEMENTO>
 * Список ведётся вручную и НЕ импортирует services-data.ts: тот модуль тянет
 * ~1400 строк SEO-контента, а сайдбар — клиентский компонент, поэтому импорт
 * раздул бы клиентский бандл на десятки килобайт ради семи ссылок.
 * </MEMENTO>
 */
export const KB_SERVICE_LINKS: { href: string; label: string }[] = [
  { href: "/uslugi/ohrana-obekta", label: "Охрана объекта" },
  { href: "/uslugi/videonablyudenie", label: "Видеонаблюдение" },
  { href: "/uslugi/ohrannaya-signalizaciya", label: "Охранная сигнализация" },
  { href: "/uslugi/gbr", label: "ГБР" },
  { href: "/uslugi/ohrana-shkoly", label: "Охрана школы" },
  { href: "/uslugi/trevozhnaya-knopka", label: "Тревожная кнопка" },
  { href: "/uslugi/montazh-oborudovaniya", label: "Монтаж оборудования" },
];

/** Инструменты и законы — вторая половина базы знаний (раньше из Вики были недоступны) */
export const KB_TOOL_LINKS: WikiNavLink[] = [
  { href: "/fz-427", label: "Готовность к 427-ФЗ", icon: ShieldCheck },
  { href: "/tools/reestr-chop", label: "Реестр ЧОП", icon: Search },
  { href: "/tools/proverka-chop", label: "Проверка ЧОП по ИНН", icon: Building2 },
  { href: "/tools/uchebnye-centry", label: "Учебные центры", icon: GraduationCap },
];

/** Партнёры — справочник партнёрских ЧОП */
export const KB_PARTNERS_LINK: WikiNavLink = {
  href: "/partners",
  label: "Партнёры",
  icon: Handshake,
};
